export const surveyQuestions = [
  'None (instant)',
  'How was your experience?',
  'How was your visit?',
  'How was your food today?',
  'How would your rate your service?'
]

export const surveyDelays = ['15 minutes', '30 minutes', '1 bour', '2 hours', '1 day']
